export enum ENUM__ml_asset_status {
  DOWNLOAD_NOT_STARTED = 'DOWNLOAD_NOT_STARTED',
  DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS',
  DOWNLOAD_ERROR = 'DOWNLOAD_ERROR',

  DUPLICATE = 'DUPLICATE',

  USING_ERROR = 'USING_ERROR',
}
